module.exports = __webpack_public_path__ + "img/counter-icon-3.4ad50a25.png";